/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useState } from "react";
import { DatePicker, DatePickerProps } from "@material-ui/pickers";
import {
  makeStyles,
  Grid,
  createStyles,
  TextField,
  Tooltip
} from "@material-ui/core";
import CalendarTodayRoundedIcon from "@material-ui/icons/CalendarTodayRounded";
// import { renderIntoDocument } from "react-dom/test-utils";
import { createTheme as createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
// import { grey, red } from "@material-ui/core/colors";
import moment from "moment";
import { ViewModeTextField } from "../text-fields/ViewModeTextField";
import { IconTooltip } from "../../icons/IconTooltip";

const outerTheme = createMuiTheme({
  typography: {
    fontFamily: "'Open Sans', sans-serif !important",
    subtitle1: {
      fontSize: 12
    },
    body1: {
      fontWeight: 600,
      fontSize: 14
    },
    button: {
      fontSize: "12px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal"
    }
  },
  overrides: {
    MuiInputLabel: {
      outlined: {
        letterSpacing: "normal",
        color: "#363b41"
      },
      formControl: {
        transform: "none !important"
      }
    },
    MuiInputBase: {
      root: {
        "&:focus": {
          borderRadius: "4px",
          border: "1px solid #cad1d7 !important"
        }
      },
      input: {
        padding: "10px",
        "&:focus": {
          borderRadius: "4px",
          border: "1px solid #cad1d7 !important"
        }
      }
    },
    MuiInput: {
      root: {
        borderBottom: "1px solid transparent"
      },
      underline: {
        "&&&&:before": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:after": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:hover:before": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:hover:after": {
          borderBottom: "1px solid transparent"
        }
      }
    },
    MuiFormHelperText: {
      contained: {
        marginRight: "0px !important",
        marginLeft: "0px !important"
      }
    },
    MuiFormLabel: {
      root: {
        "&:focus": {
          borderColor: "#cad1d7",
          borderWidth: 1
        }
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: "14px"
      },
      // adornedEnd:{
      //   justifyContent: "space-between"
      // },
      root: {
        "& $notchedOutline": {
          borderColor: "#cad1d7",
          borderWidth: 1
        },
        "&:focus": {
          borderColor: "#cad1d7",
          borderWidth: 1
        },
        "&:hover": {
          borderColor: "#cad1d7 !important",
          borderWidth: 1
        }
      }
    }
  }
});

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      // '&.MuiPickersBasePicker-pickerView':{
      //   padding: "14.5px 14px 14.5px 14px !important"
      // },
      "label + &": {
        marginTop: "4px",
        borderRadius: "4px",
        border: "1px solid"
      },
      "label + &.MuiInput-formControl": {
        borderRadius: 4,
        position: "relative",
        border: "1px solid",
        borderColor: "#cad1d7",
        fontSize: 14,
        padding: "0px 0px 0px 14px",
        alignSelf: "flex-end",
        width: "100%",
        color: "#323536"
      }
    },
    commentBox: {
      marginTop: "20px",
      flex: "none !important",
      "& label": {
        width: "100%",
        "& div": {
          "& input": {
            marginBottom: "20px"
          }
        }
      }
    },
    labelContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
      // marginTop: "1px",
    },
    labelInformation: {
      fontSize: 12,
      fontWeight: 600,
      color: "#8897aa",
      lineHeight: "16px",
      // height: "14px",
      "&:hover": {
        color: "#5e72e4"
      },
      display: "inline-block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      maxWidth: "95%",
      textOverflow: "ellipsis",
      pointerEvents: "all"
    },
    tooltip: {
      color: "#32325d",
      backgroundColor: "white",
      fontFamily: `"Open Sans", sans-serif !important`,
      fontSize: 12,
      boxShadow: "0 2px 12px 0 rgba(50, 50, 93, 0.21)",
      padding: "5px"
    },
    arrow: {
      color: "white"
    },
    labelRequired: {
      color: "#f75676",
      // marginLeft: "4px",
      fontSize: "12px",
      paddingTop: 1,
      paddingLeft: "3px"
      //  marginBottom: "4px",
    },
    iconInfoContainer: {
      height: "16px",
      textAlign: "end",
      pointerEvents: "all"
    },
    labelRequiredComments: {
      color: "#f75676",
      marginLeft: "4px",
      fontSize: "12px",
      marginBottom: "4px",
      marginTop: "5px"
    },
    iconInfo: {
      width: "16px !important",
      height: "16px !important",
      color: "#32325d",
      pointerEvents: "auto",
      "&:hover": {
        color: "#5e72e4 !important"
      }
    },
    input: {
      borderRadius: 4,
      position: "relative",
      // border: "1px solid #cad1d7",
      fontSize: 14,
      padding: "13px 12px",
      color: "#32325d",
      alignSelf: "flex-end",
      // transition: theme.transitions.create(["box-shadow"]),
      "&:focus": {
        "text-decoration-line": "none"
        // borderRadius: "4px",
        // border: "solid 1px #5e72e4 !important",
      }
    },
    iconCalender: {
      fontSize: "1rem !important",
      color: "#32325D",
      pointerEvents: "auto",
      "&:hover": {
        color: "#5e72e4"
      }
    },
    activeBorder: {
      marginTop: "-5px !important",
      "&:focus": {
        border: "1px solid #5e72e4"
      }
    }
  })
);

export function GridDatePickerForm(
  props: DatePickerProps & {
    labelHeader?: string;
    valueTestId?: string;
    isViewMode?: boolean;
    editedLabel?: any;
    editedData?: any;
    required?: boolean;
    infoText?: string;
    style?: any;
    onBlur?: any;
    onReasonBlur?: (event: React.FocusEvent<HTMLInputElement>) => void | any;
    error?: boolean;
    helperText?: string;
    renderInput?: any;
    editComponent?: any;
    infoIconData?: any;
    disableInfoIcon?: boolean;
    isNotInfo?: boolean;
    formatterFunction?: (arg0: any) => any;
    dateFormatString?: string;
    avoidConverison?: boolean;
    onClickCalender?: any;
    enableReason?: boolean;
    fromSettelement?: boolean;
    customStyle?: any;
    isServicerMandatory?: boolean;
  }
) {
  const {
    style,
    valueTestId,
    error,
    label,
    isViewMode,
    editedData,
    editedLabel,
    infoIconData,
    onBlur,
    onReasonBlur,
    required,
    infoText,
    editComponent,
    disableInfoIcon,
    isNotInfo,
    formatterFunction,
    dateFormatString,
    avoidConverison,
    onClickCalender,
    enableReason = false,
    customStyle = {},
    fromSettelement,
    isServicerMandatory,
    ...remainingProps
  } = props;
  // const tempProps: { [index: string]: any } = props;
  const classes = useStyles();
  const cookievalue = `; ${document.cookie}`;
  // eslint-disable-next-line no-useless-concat
  const parts = cookievalue.split("; " + "loginFlow" + "=");
  let loginflow;
  if (parts.length === 2) {
    loginflow = parts
      ?.pop()
      ?.split(";")
      ?.shift();
  } else {
    loginflow = null;
  }

  const isLATUser = loginflow === "LAT";

  function convertToLocalDate(date: any, dateFormat: string) {
    const d = moment.utc(`${date}`, dateFormat).toDate();
    const tzoffset = new Date(d).getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime =
      tzoffset < 0 ? new Date(d.getTime()) : new Date(d.getTime() + tzoffset);
    const a = moment.utc(localISOTime).toDate();
    return a;
  }

  function defaultDateFormat(date: any) {
    try {
      if (!date) return "";
      let nDate = date;
      if (typeof nDate === "number") {
        nDate = moment(new Date(nDate));
      } else if (typeof nDate === "string") {
        // eslint-disable-next-line prefer-destructuring
        nDate = String(nDate).split("T")[0];
      }
      return moment.utc(nDate).format("MMM DD, YYYY");
    } catch (err) {
      return "";
    }
  }

  function isEmptyValue(inputValue: any) {
    let value = inputValue;
    if (typeof value === "string") value = value.trim();
    return value === "" || value === null || value === undefined;
  }

  function convertToYYYYMMDD(date: any, dontSplitTillT?: boolean) {
    if (isEmptyValue(date)) return null;
    try {
      const d = moment(new Date(date), "YYYY-MM-DD").toDate();
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = d.getFullYear();
      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
      // eslint-disable-next-line no-shadow
    } catch (error) {
      return null;
    }
  }

  const onChangeTrigger = (date: any) => {
    if (!avoidConverison) remainingProps.onChange(convertToYYYYMMDD(date));
    else remainingProps.onChange(date);
  };
  const newProps = {
    ...remainingProps,
    onChange: onChangeTrigger
  };
  let formatedVal: any = "";
  if (formatterFunction) formatedVal = formatterFunction(newProps.value);
  else formatedVal = defaultDateFormat(newProps.value);

  const localeDate: any = convertToLocalDate(
    formatedVal,
    dateFormatString || "MMM DD, YYYY"
  );

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return isViewMode ? (
    <ViewModeTextField
      label={label}
      style={style}
      infoIconData={infoIconData}
      value={formatedVal}
      editedLabel={editedLabel}
      editedData={editedData}
      editComponent={editComponent}
      isNotInfo={isNotInfo}
      fromSettelement={fromSettelement}
      isServicerMandatory={isServicerMandatory}
    />
  ) : (
    <ThemeProvider theme={outerTheme}>
      <DatePicker
        label={
          label && (
            <Grid
              container
              item
              xs={12}
              sm={12}
              className={classes.labelContainer}
            >
              <Grid item xs={12} md={12} sm={12} container>
                <Grid
                  item
                  xs={10}
                  md={!disableInfoIcon && infoIconData ? 11 : 12}
                >
                  <Tooltip
                    title={`${label}`}
                    placement="right"
                    arrow
                    classes={{
                      tooltip: classes.tooltip,
                      arrow: classes.arrow
                    }}
                  >
                    <span
                      className={classes.labelInformation}
                      style={customStyle}
                    >
                      {label}
                    </span>
                  </Tooltip>
                  {required && (
                    <span className={classes.labelRequired}>
                      <sup>*</sup>
                    </span>
                  )}
                </Grid>
                {!disableInfoIcon && infoIconData ? (
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    md={1}
                    className={classes.iconInfoContainer}
                  >
                    <IconTooltip
                      topic="Information"
                      infoIconData={infoIconData}
                    />
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
          )
        }
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        inputFormat="MMM dd, yyyy"
        InputProps={{
          endAdornment: (
            <CalendarTodayRoundedIcon
              className={classes.iconCalender}
              onClick={handleOpen}
            />
          ),
        }}
        openPickerIcon={
          !onClickCalender ? (
            <CalendarTodayRoundedIcon className={classes.iconCalender} />
          ) : (
            <CalendarTodayRoundedIcon
              className={classes.iconCalender}
              onClick={onClickCalender}
            />
          )
        }
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...newProps}
        value={localeDate}
        renderInput={newProps.renderInput}
        showToolbar={false}
      />
      {(editedLabel && isLATUser) || (editedLabel && enableReason) ? (
        <TextField
          InputProps={{ classes }}
          className={classes.commentBox}
          InputLabelProps={{
            style: {
              position: "relative",
              fontWeight: 600,
              fontSize: 12,
              color: "#32325d",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
              // border: "1px solid #cad1d7",
            }
          }}
          onBlur={onReasonBlur || onBlur}
          label={
            <Grid
              container
              item
              xs={12}
              sm={12}
              className={classes.labelContainer}
            >
              <Grid item xs={12} md={12} sm={12} container>
                {/* <span className={classes.labelInformation}> */}
                <Tooltip
                  title={`${label}`}
                  placement="right"
                  arrow
                  classes={{
                    tooltip: classes.tooltip,
                    arrow: classes.arrow
                  }}
                >
                  <span className={classes.labelInformation}>
                    {`Reason For Editing ${label}`}
                  </span>
                </Tooltip>
                {/* </span> */}
                {/* {required ? ( */}
                <span className={classes.labelRequiredComments}>
                  <sup>*</sup>
                </span>
                {/* ) : (
                    ""
                  )} */}
              </Grid>
            </Grid>
          }
          style={{
            width: "100%",
            marginTop: "20px !important",
            ...style
          }}
        />
      ) : (
        ""
      )}
    </ThemeProvider>
  );
}
